import React from "react";
import Select from "../../../../../../common/StyledSelect";
import CustomTextField from "../CustomTextField";
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  packageTypeSelectWrap: {
    width: "100%",
    "& > div": {
      width: "100%",
    },
  },
});

const PackageFieldInput = ({
  classes,
  fieldName,
  fieldConfig,
  handleChange,
  errorInfo,
  editInfo,
  packageTypeList,
  packageIndex,
}) => {
  // Model key on each packaging row: config `dataKey` only when it differs from `field` (e.g. packageType → packageCode); else `fieldName`.
  const modelKey = fieldConfig.dataKey ?? fieldName;
  const value = editInfo.packagingItems[packageIndex][modelKey];
  const error = errorInfo.packagingItemsErrorInfo[packageIndex]?.[modelKey];

  if (fieldConfig.type === "select") {
    return (
      <div className={classes.packageTypeSelectWrap}>
        <Select
          textFieldProps={{
            id: modelKey,
            label: fieldConfig.label,
            variant: "outlined",
            helperText: error,
          }}
          value={value}
          error={Boolean(error)}
          onChange={handleChange(modelKey, packageIndex)}
          data={packageTypeList}
        />
      </div>
    );
  }

  return (
    <CustomTextField
      id={fieldName}
      handleChange={handleChange(modelKey, packageIndex)}
      value={value}
      error={error}
      label={fieldConfig.label}
      inputProps={{ min: fieldConfig.minValue, max: fieldConfig.maxValue }}
      type={fieldConfig.type}
    />
  );
};

export default withStyles(styles)(PackageFieldInput);
